import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt";
import EditableDescription from "../../utils-components/editable-description";
import { SAVE_DOCUMENT_REQUEST_CLASSIFICATION_DESCRIPTION, DELETE_DOCUMENT_REQUEST_CLASSIFICATION, UPLOAD_DOCUMENT_TO_REQUEST_CLASSIFICATION } from "../../../store/documents-actions";
import { mapActions } from "vuex";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentRequestListHeader",
  components: {
    InlinePrompt,
    EditableDescription
  },
  props: {
    documentRequest: {
      type: Object,
      required: true
    },
    documentRequestListName: {
      type: String,
      required: true
    },
    hasSampleDocuments: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploading: false,
      savingDescription: false,
      labelValue: uuidv4()
    };
  },
  computed: {
    description() {
      return this.documentRequest.description;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [SAVE_DOCUMENT_REQUEST_CLASSIFICATION_DESCRIPTION, DELETE_DOCUMENT_REQUEST_CLASSIFICATION, UPLOAD_DOCUMENT_TO_REQUEST_CLASSIFICATION])), {}, {
    async handleSaveDescription({
      description
    }) {
      this.savingDescription = true;
      await this.SAVE_DOCUMENT_REQUEST_CLASSIFICATION_DESCRIPTION({
        documentRequestId: this.documentRequest.id,
        documentRequestListName: this.documentRequestListName,
        description
      });
      this.savingDescription = false;
    },
    async handleDelete() {
      await this.DELETE_DOCUMENT_REQUEST_CLASSIFICATION({
        documentRequestId: this.documentRequest.id,
        documentRequestListName: this.documentRequestListName
      });
    },
    async handleFilesSelected(event) {
      const files = event.target.files;
      if (!(files != null && files.length)) return;
      this.uploading = true;
      await this.UPLOAD_DOCUMENT_TO_REQUEST_CLASSIFICATION({
        documentRequest: this.documentRequest,
        files
      });
      this.$refs.fileInput.value = "";
      this.uploading = false;
    }
  })
});